<div class="wrapper-header sticky-header">
  <h1>{{ title }}</h1>
  <div class="action-header-bar">
    <button matIconButton type="button" class="btn-action" (click)="onCancel()" matTooltip="Cancel"
            matTooltipPosition="above"
            aria-label="Cancel">
      <mat-icon class="material-symbols-outlined" fontIcon="cancel"/>
    </button>
    <button matIconButton type="button" class="btn-action" (click)="onReset()" matTooltip="Reset"
            matTooltipPosition="above"
            aria-label="Reset">
      <mat-icon class="material-symbols-outlined" fontIcon="refresh"/>
    </button>
    <button matIconButton
            type="button"
            class="btn-action"
            (click)="onSave()"
            matTooltip="Save"
            matTooltipPosition="above"
            aria-label="Save">
      <mat-icon class="material-symbols-outlined" fontIcon="save"/>
    </button>
  </div>
</div>

<!-- Stepper component -->
<app-utility-stepper [steps]="steps"
                     [currentStep]="currentStep"
                     [isLinear]="false"
                     [enableValidation]="validateOnRender"
                     (stepChange)="onStepChange($event)"
                     (stepActivate)="onStepActivate($event)">
  @for (step of steps; track step.label; let i = $index) {
    @if (currentStep === i) {
      @switch (step.label) {
        @case (workflowStep.DETAILS) {
          <workflow-detail [buildAction]="buildAction"/>
        }
        @case (workflowStep.INSTRUCTIONS) {
          <workflow-instructions/>
        }
        @case (workflowStep.SECURITY) {
          <workflow-security/>
        }
        @case (workflowStep.ADMIN) {
          <workflow-admin/>
        }
        @case (workflowStep.SUMMARY) {
          <workflow-summary/>
        }
      }
    }
  }
</app-utility-stepper>
